
import AddCaptinCard from "../components/add_captin_card";
import {SignInCard} from "../components/sign_in_card";
import {SignupCard} from "../components/sign_up_card";

export const SignUp = () =>{
  


  return (
   
    <div>
      <SignupCard/>
    </div>
  );
}

export const SignIn = () =>{
  


  return (
   
    <div>
      <SignInCard/>
    </div>
  );
}

export const AddCaptin = () =>{
  


  return (
   
    <div>
      <AddCaptinCard/>
    </div>
  );
}